import React from 'react';
import PartnerForm from './PartnerForm'; // Importez le composant PartnerForm

const UpdatePartner = () => {
  return <PartnerForm isEdit={true} />;
};

export default UpdatePartner;
